import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { HelperService } from '../../../Services/helper.service';
import { TranslationService } from '../../../Services/translation.service';
import { SwiperOptions } from 'swiper/types';
import { SwiperContainer } from 'swiper/element';


@Component({
  selector: 'app-homerecommended',
  templateUrl: './homerecommended.component.html',
  styleUrls: ['./homerecommended.component.css']
})
export class HomerecommendedComponent implements OnInit {
  @Input() recommendedBanners: any;
  contentLoaded: boolean = false;
  showBanners: boolean = false;
  config: SwiperOptions = {
      init: true,
      navigation: {
        prevEl: '#prev-rec',
        nextEl: '#next-rec'
      },
      slidesPerView: 1,
      updateOnWindowResize: false,
      spaceBetween: 20,
      breakpoints: {
      '320': {
        slidesPerView: 1.1,
        spaceBetween: 10
      },
      '580': {
        slidesPerView: 2,
        centeredSlides: true,
        spaceBetween: 10
      },
      '768': {
        slidesPerView: 3,
        spaceBetween: 10
      },
      '991': {
        slidesPerView: 4
      },
      '1280':{
        slidesPerView: 4.5,
        loopAdditionalSlides: 6
      }

    }
  }
  @ViewChild('recommendedSlider') swiper!: ElementRef<SwiperContainer>;

  word: any = {};
  language: string = '';

  constructor(
    private helperService: HelperService,
    private translationService: TranslationService
  ) {
    this.word = this.translationService.word;
    this.language = this.translationService.language;
  }

  ngOnInit(): void {
    const city = this.helperService.getCity();

    if (city != 'tarnovo' && city != 'bansko') {
      this.recommendedBanners = this.recommendedBanners.response?.DataRows[0]?.Data;
      this.contentLoaded = true;
      this.showBanners = true;
    }
  }
  ngAfterViewInit(): void{
    Object.assign(this.swiper, this.config);
    this.swiper.nativeElement.initialize();
  }
}
